// @ts-nocheck
import { Button, Input, message, Select, Spin, Tooltip } from "antd";
import { bulk_invitation_limit } from "../../../../config";
import { getIntFromString, validateEmail } from "modules/look";
import { dashboard_home_icons, organization_icons } from "modules/poc-dashboard/icons";
import React from "react";
import usePrompt from "modules/usePrompt";
import poc_dashboard_routes from "modules/poc-dashboard/routes";


const CreateInvitationUserView = (props) => {
    const { navigateRoute,
        verticals,
        verticalLoading,
        getTeamList,
        teams,
        app_sidebar_expand,
        getverticalList,
        SetRegisterData,
        formData,
        setFormData,
        loadingapi,
        orgToFetchData,
        location,
        me
    } = props
    // eslint-disable-next-line no-unused-vars
    const { isDirty, setIsDirty, PromptComponent } = usePrompt("Are you sure you want to leave? You have unsaved changes.");
    let form_key = React.useRef(1)

    const user_type = [
        {
            value: "vertical_head",
            label: "Vertical Head"
        },
        {
            value: "manager",
            label: "Manager"
        },
        {
            value: "employee",
            label: "Employee"
        }
    ]

    const addForm = () => {
        if (formData?.length >= bulk_invitation_limit) {
            message.destroy()
            message.error(`Cannot invite more than ${bulk_invitation_limit} employees at a time.`)
        }
        form_key.current = form_key?.current + 1
        let form_data = [...formData];
        form_data.push({ key: form_key?.current, vertical: null, team: null, email: null, firstName: null, lastName: null, user_type: null, error: false, error_message: null, success: false })
        setFormData(form_data);
        setTimeout(() => {
            let doc = document.getElementById("auto-scroll-view")
            if (doc) {
                doc.scrollIntoView({ inline: "end", behavior: "smooth" })
            }
        }, 250);
    };

    const handleChange = (key, field, value) => {
        const updatedFormData = [...formData];
        let node = updatedFormData?.find(i => String(i?.key) === String(key))
        if (node) {
            node[field] = value?.trim();
            if (field === "vertical") {
                node.team = null
                getTeamList({ key, vertical: getIntFromString(value) })
            }
            setFormData(updatedFormData);
            formUpdatedValidation(updatedFormData)
        }
    };

    const formUpdatedValidation = (data) => {
        if (data?.length) {
            let form_fields = ["vertical", "team", "email", "firstName", "lastName", "user_type"]
            let form_updated = data.find(i => {
                let data_changed = false
                form_fields.forEach(f => {
                    if (i[f]) {
                        data_changed = true
                    }
                })
                return data_changed
            })
            if (form_updated) {
                setIsDirty(true)
            } else {
                setIsDirty(false)
            }
        } else {
            setIsDirty(false)
        }
    }

    const handleInvitation = () => {
        if (!formData?.length) {
            message.error("Please add data")
            return
        }
        let list = formData?.map(i => {
            let validation = checkValidation(i)
            return {
                ...i,
                error: !validation?.valid,
                error_message: validation?.error_message
            }
        })
        let invalid_data = list?.find(i => i.error)
        setFormData(list)
        if (!invalid_data) {
            setIsDirty(false)
            SetRegisterData(list)
        }
    }

    const checkValidation = (value) => {
        if (!value.vertical) {
            message.error("Please select a vertical")
            return {
                valid: false,
                error_message: "Please select a vertical"
            }
        }
        else if (!value.firstName || !value.lastName) {
            message.error("Please provide name")
            return {
                valid: false,
                error_message: "Please provide name"
            }
        }
        else if (!value.email || !validateEmail(value?.email)) {
            message.error("Please provide valid email")
            return {
                valid: false,
                error_message: "Please provide valid email"
            }
        }
        else if (!validateEmailDomain(value?.email)) {
            message.error("Users email domain didn't match with organization domain")
            return {
                valid: false,
                error_message: "Users email domain didn't match with organization domain"
            }
        }
        else if (!value?.user_type) {
            message.error("Please select position")
            return {
                valid: false,
                error_message: "Please select position"
            }
        }
        else if (value.user_type === "manager" && !value?.team) {
            message.error("Please select a team")
            return {
                valid: false,
                error_message: "Please select a team"
            }
        }
        else {
            return {
                valid: true
            }
        }
    }

    const validateEmailDomain = (email) => {
        if (orgToFetchData?.id) {
            const selectedOrg = Object.values(poc_dashboard_routes).some(routes => location?.pathname.includes(routes))
                ? me?.employee?.orgPocEmployee?.edges?.[0]?.node
                : me?.employee?.orgAmEmployee?.edges?.filter(({ node }) => node?.id === orgToFetchData?.id)?.[0]?.node
            let list = selectedOrg?.email?.split('@')
            if (list?.length) {
                let organization_email_domain = list[1]
                if (organization_email_domain) {
                    return email?.includes(`@${organization_email_domain}`)
                } else {
                    return false
                }
            } else {
                return false
            }
        } else {
            return false
        }
    }
    const removeCell = (data) => {
        let list = [].concat(formData)
        let cell = list.find(i => String(i?.key) === String(data?.key))
        if (cell) {
            list = list?.filter(i => String(i?.key) !== String(data?.key))
            setFormData(list)
        }
    }

    const onCancel = () => {
        setIsDirty(false)
        setTimeout(() => {
            navigateRoute("-1")
        }, 300);
    }

    return (
        <Spin spinning={loadingapi || verticalLoading} size="large">
            <div className="poc-dahboard-root">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", gap: "1em", alignItems: "center" }}>
                    <img src={organization_icons?.back_arrow} alt="back_arrow" style={{ width: "25px", cursor: "pointer" }} onClick={() => navigateRoute("-1")} />
                    <h4 className="poc-dashboard-card-title">Invite Employees</h4>
                </div>
                <div className="poc-org-root create-employee-invitation-root" style={{ marginTop: "1em", width: "100%", padding: '1em' }}>

                    <div className="poc-height-limit" id="poc-height-limit">
                        <div className="poc-employee-invite-container invitation-overflow">
                            <table className="poc-employee-invite-table">
                                <thead>
                                    <tr>
                                        <th className='invite-form-label' style={{ textAlign: 'left', whiteSpace: "nowrap" }}>Vertical<span style={{ color: "#E86161" }}>*</span></th>

                                        <th className='invite-form-label' style={{ textAlign: 'left', whiteSpace: "nowrap" }}>Team</th>

                                        <th className='invite-form-label' style={{ textAlign: 'left', whiteSpace: "nowrap" }}>Email<span style={{ color: "#E86161" }}>*</span></th>

                                        <th className='invite-form-label' style={{ textAlign: 'left', whiteSpace: "nowrap" }}>First Name<span style={{ color: "#E86161" }}>*</span></th>

                                        <th className='invite-form-label' style={{ textAlign: 'left', whiteSpace: "nowrap" }}>Last Name<span style={{ color: "#E86161" }}>*</span></th>

                                        <th className='invite-form-label' style={{ textAlign: 'left', whiteSpace: "nowrap" }}>Position<span style={{ color: "#E86161" }}>*</span></th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {formData?.map((field, index) => (
                                        <Tooltip title={(field?.error && field.error_message) ? field.error_message : ""}>
                                            <tr key={field?.key} className={`poc-invite-table-body ${field?.error ? "create-invite-form-invalid" : ""} `}>

                                                <td className="invite-table-border-left">
                                                    <Select
                                                        className='org-poc-select-filed invite-form-input'
                                                        showSearch={true}
                                                        style={{ width: "100%", borderColor: "rgba(213, 229, 242, 1)" }}
                                                        placeholder="Select Vertical"
                                                        onChange={(e) =>
                                                            handleChange(field?.key, "vertical", e)
                                                        }
                                                        filterOption={false}
                                                        onSearch={(e) => getverticalList({ search: e })}
                                                        value={field.vertical}
                                                    >
                                                        {
                                                            verticals?.map(item => {
                                                                return <Select.Option className="org-option" key={item?.id} value={item?.id} >{item?.name}</Select.Option>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                                <td>
                                                    <Select
                                                        className='org-poc-select-filed invite-form-input'
                                                        showSearch={true}
                                                        style={{ width: "100%", borderColor: "rgba(213, 229, 242, 1)" }}
                                                        placeholder="Select Team"
                                                        onChange={(e) =>
                                                            handleChange(field?.key, "team", e)
                                                        }
                                                        filterOption={false}
                                                        value={field?.team}
                                                        disabled={!field?.vertical}
                                                        onSearch={(e) => getTeamList({ key: field?.key, vertical: getIntFromString(field?.vertical), search: e })}
                                                    >
                                                        {
                                                            teams[`team_${field?.key}_${getIntFromString(field?.vertical)}`]?.map(item => {
                                                                return <Select.Option className="org-option" key={item?.id} value={item?.id} >{item?.name}</Select.Option>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                                <td>
                                                    <Input
                                                        className='vertical-input invite-form-input'
                                                        name="email" maxLength={200}
                                                        style={{ height: "2.5em", borderColor: "rgba(213, 229, 242, 1)", fontSize: '1em' }}
                                                        placeholder='Enter Email Id'
                                                        value={field.email}
                                                        onChange={(e) =>
                                                            handleChange(field?.key, "email", e.target.value)
                                                        }
                                                        autoComplete="off"
                                                    ></Input>
                                                </td>
                                                <td>
                                                    <Input
                                                        className='vertical-input invite-form-input'
                                                        name="email"
                                                        maxLength={200}
                                                        style={{ height: "2.5em", borderColor: "rgba(213, 229, 242, 1)", fontSize: '1em' }}
                                                        placeholder='Enter Firstname'
                                                        value={field.firtName}
                                                        onChange={(e) =>
                                                            handleChange(field?.key, "firstName", e.target.value)
                                                        }
                                                        autoComplete="off"
                                                    ></Input>
                                                </td>
                                                <td>
                                                    <Input
                                                        className='vertical-input invite-form-input'
                                                        name="email"
                                                        maxLength={200}
                                                        style={{ height: "2.5em", borderColor: "rgba(213, 229, 242, 1)", fontSize: '1em' }}
                                                        placeholder='Enter Lastname'
                                                        value={field.lastName}
                                                        onChange={(e) =>
                                                            handleChange(field?.key, "lastName", e.target.value)
                                                        }
                                                        autoComplete="off"
                                                    ></Input>
                                                </td>
                                                <td className="invite-table-border-right">
                                                    <div className="action-row-container">
                                                        <Select
                                                            className='org-poc-select-filed invite-form-input'
                                                            showSearch={true}
                                                            style={{ width: "100%", borderColor: "rgba(213, 229, 242, 1)" }}
                                                            placeholder="Select Position"
                                                            onChange={(e) =>
                                                                handleChange(field?.key, "user_type", e)
                                                            }
                                                        >
                                                            {
                                                                user_type?.map(item => {
                                                                    return <Select.Option className="org-option" key={item?.value} value={item?.value} >{item?.label}</Select.Option>
                                                                })
                                                            }
                                                        </Select>
                                                        <img src={dashboard_home_icons?.close_icons} alt="" onClick={() => removeCell(field)} style={{ cursor: "pointer" }} />
                                                    </div>
                                                </td>

                                            </tr>
                                        </Tooltip>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div id="auto-scroll-view" style={{ width: "1px", height: "1px" }}></div>
                    </div>
                    <Button className="add-mode-btn" onClick={() => addForm()} disabled={formData?.length >= bulk_invitation_limit}>Add More</Button>
                    {
                        formData?.length >= bulk_invitation_limit ?
                            <p style={{ color: "#E86161", marginTop: "0.25em" }}>* You can only invite {bulk_invitation_limit} employees at once.</p> : null
                    }

                </div>
                <div className={`one-on-one-bottom-div ${app_sidebar_expand ? 'one-on-one-div-margin-left' : ''}`}>
                    <Button className="org-invite-cancel-btn" style={{ width: "7em" }} onClick={() => onCancel()}>Cancel</Button>
                    <Button className="poc-active-btn" style={{ width: "7em" }} onClick={() => handleInvitation()} disabled={!formData?.length}>Invite</Button>
                </div>
            </div>
            {PromptComponent}
        </Spin>
    )
}

export default CreateInvitationUserView;